import { styled } from 'linaria/lib/react';
import { BREAKPOINTS, COLORS, FONTS } from 'styles/constants';

export const StyledHeaderWrap = styled.div<{ shouldShow: boolean }>`
  padding: 32px 24px 16px;
  transform: translateY(${({ shouldShow }) => (shouldShow ? '0' : '-100%')});
  opacity: ${({ shouldShow }) => (shouldShow ? '1' : '0')};
  max-height: ${({ shouldShow }) => (shouldShow ? '1000px' : '0')};
  overflow: hidden;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out, max-height 0.3s ease-out, padding 0.3s ease-out;
  padding-top: ${({ shouldShow }) => (shouldShow ? '32px' : '0')};
  padding-bottom: ${({ shouldShow }) => (shouldShow ? '16px' : '0')};

  p {
    font: 400 22px/130% ${FONTS.primary};
    margin: 0;
  }

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding-left: ${({ shouldShow }) => (shouldShow ? '12px' : '24px')};
  }
`;

export const StyledSectionWrap = styled.div`
  padding: 24px 0;
`;

export const StyledSectionElement = styled.div`
  padding: 0 12px;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding: 0;
  }
`;

export const StyledTextContainer = styled.div`
  padding: 0 24px;
  cursor: pointer;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding: 0 12px;
  }
`;

export const StyledSectionType = styled.div`
  color: ${COLORS.brown.light[100]};
  font-family: ${FONTS.secondary};
  font-size: 14px;
  padding-bottom: 16px;
`;

export const StyledSvgContainer = styled.div<{ isDark: boolean }>`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg {
    height: 24px;
    width: 24px;
    opacity: 0.8;
    color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
  }
`;

export const StyledTitle = styled.p<{ isDark: boolean }>`
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 22px;
  margin: 0;

  a {
    align-items: center;
    color: inherit;
    display: flex;
    justify-content: flex-start;
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(22px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledText = styled.p`
  font: 400 14px/140% ${FONTS.secondary};
`;

export const StyledSliderWrap = styled.div`
  display: flex;

  > div {
    flex: 1;
  }

  .swiper-slide {
    height: auto;
    width: 156px;
  }
`;

export const StyledRefreshLoader = styled.div<{ isRefreshing: boolean }>`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  max-height: ${({ isRefreshing }) => (isRefreshing ? '100px' : '0')};
  opacity: ${({ isRefreshing }) => (isRefreshing ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out, padding 0.3s ease-out;
  padding-top: ${({ isRefreshing }) => (isRefreshing ? '16px' : '0')};
  padding-bottom: ${({ isRefreshing }) => (isRefreshing ? '16px' : '0')};
`;
